export const FAQS = [
  {
    q: "Apa itu Mika Solution?",
    a: "Mika Solution adalah layanan konsultasi dan pendampingan penyelesaian kewajiban finansial, meliputi pinjaman online (pinjol), kartu kredit, dan Kredit Tanpa Agunan (KTA). Kami membantu Anda memahami kondisi kewajiban dan pilihan penyelesaian yang mungkin tersedia.",
  },
  {
    q: "Apa hubungan Mika Solution dengan Mitra Karya Law Office?",
    a: "MIKA SOLUTION merupakan bagian dari Mitra Karya Law Office. Mika Solution berfokus pada konsultasi dan pendampingan penyelesaian kewajiban finansial bagi masyarakat.",
  },
  {
    q: "Apakah Mika Solution melayani konsultasi Pinjol?",
    a: "Ya. Kami melayani konsultasi dan pendampingan untuk kewajiban pinjaman online, selain kartu kredit dan KTA.",
  },
  {
    q: "Apakah semua pinjaman online dapat memperoleh potongan?",
    a: "Tidak selalu. Melalui Program Lunas Diskon, potongan dapat diupayakan hingga 50% dari total tagihan, dan untuk pinjol tersedia Program Balik Pokok. Namun hasilnya bergantung pada kondisi akun, kebijakan penyedia pinjaman, dan persetujuan pihak terkait, sehingga tidak dapat dijamin.",
  },
  {
    q: "Apakah tunggakan dapat diselesaikan dengan cicilan?",
    a: "Program cicilan adalah salah satu opsi yang mungkin tersedia, tetapi pelaksanaannya bergantung pada persetujuan kreditur atau penyedia pinjaman.",
  },
  {
    q: "Apakah konsultasi awal gratis?",
    a: "Ya, konsultasi awal tidak dikenakan biaya. Biaya hanya berlaku apabila Anda memutuskan menggunakan layanan pendampingan dan telah menyetujui ketentuannya.",
  },
  {
    q: "Bagaimana proses pendampingan berlangsung?",
    a: "Prosesnya meliputi konsultasi awal, evaluasi kondisi, penjelasan opsi dan biaya, pendampingan sesuai kesepakatan tertulis, lalu dokumentasi dan tindak lanjut hasil.",
  },
  {
    q: "Berapa biaya layanan?",
    a: "Biaya layanan bergantung pada kondisi dan ruang lingkup pendampingan. Seluruh biaya dijelaskan secara transparan dan disepakati secara tertulis sebelum pendampingan dimulai.",
  },
  {
    q: "Bagaimana informasi pribadi dilindungi?",
    a: "Data Anda hanya digunakan untuk keperluan konsultasi dan pendampingan. Kami tidak pernah meminta PIN, CVV, password, OTP, atau kredensial perbankan Anda. Selengkapnya dapat dibaca di Kebijakan Privasi.",
  },
  {
    q: "Apakah hasil penyelesaian dapat dijamin?",
    a: "Tidak. Hasil penyelesaian bergantung pada kondisi akun dan persetujuan kreditur atau penyedia pinjaman. Kami berkomitmen menjalankan proses secara transparan dan terdokumentasi.",
  },
  {
    q: "Apa yang perlu dipersiapkan sebelum konsultasi?",
    a: "Siapkan daftar kewajiban (nama kreditur atau aplikasi), perkiraan total tagihan, status tunggakan, dan gambaran kemampuan bayar bulanan Anda.",
  },
  {
    q: "Bagaimana cara menghubungi Mika Solution?",
    a: "Anda dapat menghubungi kami melalui tombol WhatsApp di situs ini atau mengisi formulir konsultasi. Tim kami akan menghubungi Anda untuk tahap berikutnya.",
  },
];
